(() => {
  const ROOT_SELECTOR = '[data-hr-home-owned]';
  const GOOD_HIGH_HEADING_SELECTOR = '[data-rid="53eefd54-4036-4a91-9b0f-5f14d809932c"]';
  const revealObservers = new WeakMap();

  const ANCHOR_ACTIONS = {
    '2d1956d7-bc18-46bf-a284-8d2df8d698e4': 'spirit',
    '70cdd0bb-3f07-4a88-98a5-ecfb7e720565': 'spirit',
    '822d357e-ba17-438d-807d-dfd7c82dbb33': 'vibe',
    '6aefdfbd-15fa-4104-9dd1-68f4a8df5148': 'rush',
    '87fe6c7d-7a01-496e-adf2-be8e7a9c4b40': 'orbit',
    'e17bbb83-0a64-4bb8-b550-b7791f7d065f': 'orbit',
    'bee66025-cef8-4d48-b7d3-a8db07f81554': 'rewards',
    '8fe83dc0-df2a-4e8a-a703-579379828bcb': 'orbit',
    '9f824486-fd8f-413c-8d65-5f83981c6fdc': 'instagram',
    '9405a59a-3123-42e1-a499-6b999323e507': 'shirts'
  };

  const DIV_ACTIONS = {
    '3a089b79-b8c9-469f-a88e-4b6f77db1e61': {
      link: 'instagram',
      label: 'View High Rider on Instagram'
    },
    'a74e6e62-5569-4be7-97e0-696625dadcc2': {
      link: 'instagram',
      label: 'View High Rider on Instagram'
    },
    '19cc2045-721f-4bae-a82d-3db0e7843862': {
      link: 'instagram',
      label: 'View High Rider on Instagram'
    },
    '595b6098-757f-45f8-99d0-f1afeab5be92': {
      link: 'shirts',
      label: 'Shop High Rider shirts'
    },
    '0922b6ed-bb4e-4a8d-94be-232096a6b02c': {
      link: 'hats',
      label: 'Shop High Rider hats'
    },
    '019f660a-b7e2-4aea-8dfe-3674b2781138': {
      link: 'hoodies',
      label: 'Shop High Rider hoodies'
    }
  };

  const COPY_RIDS = {
    heroEyebrow: 'eb84fd33-66ee-44e6-ad3f-d809484cd3ba',
    heroHeading: 'ece9c781-5456-4a18-a61d-a505166ddbfa',
    heroBody: 'e93653c0-c8cd-4bf4-808d-5112532dc4f0',
    heroCta: '689e8ab2-1511-4a72-bd9c-19b00b45fdb0',
    selectorHeading: '85189e12-97cc-4d81-ba1f-d5a993ae75a7',
    selectorBody: '4530ba66-f1bf-4600-8552-be5c7e1b9d89',
    reviewsEyebrow: '8e421499-c094-43b6-8eb2-b68fbf7c78b6',
    reviewsCta: '52b25d65-e08e-4024-adec-95faf671e718',
    socialHeading: '614dad7d-ae23-4926-b5d9-54746246aa77',
    socialBody: '47ef9c16-25f5-4c36-b637-3dee6ecb9313',
    socialCta: '1381e235-deef-4c98-a504-f645676b333b',
    merchHeading: 'd7b49848-eba4-42ce-b6e4-261a4a5a53e1',
    merchCta: '2e92f708-34f6-4c2c-bcfb-7b659faeaf09',
    rewardsHeading: 'b9c47495-a001-4128-bae6-fff9e56714af',
    rewardsCta: '121c8af2-c6ea-42e9-a3bb-4e38f6430507',
    faqHeading: '3f1f7150-fb69-42a6-9730-cd8bc9cddd26',
    finalCta: 'd3fa343d-fc08-4f14-9556-4e17c8fd4d4c'
  };

  const PRODUCT_COPY_RIDS = {
    spirit: {
      label: 'cef2871f-bbc6-4ce9-ac55-2ae027b9aded',
      dose: 'f7f70c2d-c3cd-44ca-86a9-da1861763d06',
      cta: 'b8fa333c-456a-43db-9ecd-2777d9238285'
    },
    vibe: {
      label: '84bfb3cf-91a6-4d2a-82a2-f18bc7101d0b',
      dose: '417d2bb5-6f6d-4649-9524-b2b636871287',
      descriptor: 'fa057f1b-7aaa-435a-a7bc-3798517f3bbb',
      cta: '1ce19715-7f9a-4c3c-8a67-bff672bb7a7e'
    },
    rush: {
      label: '208af396-d12e-4ce8-9a22-bf0205928574',
      dose: 'c9fc0762-865e-437a-b90f-e799d2f524e8',
      descriptor: '776f69ac-9a9a-4dd7-b8e2-149b073aef49',
      cta: '3aa3cd97-bee5-4573-9a7e-ac6a3f096d86'
    },
    orbit: {
      label: '4edd3c1d-8cd4-474c-8ca5-415a05b6bb47',
      dose: '955d7277-2657-4bd8-bbb0-932187f16599',
      descriptor: 'a8eea4b2-8d43-478b-ae8b-7b6e44cb2135',
      cta: '827739a6-d42e-4b71-9055-031131784860'
    }
  };

  const REWARD_COPY_RIDS = {
    '1': '642efe0f-e8dd-4132-8234-6cec1fb46301',
    '2': '36dfc1c9-892c-4093-8164-6ef4c66c8a11',
    '3': 'b3029fbe-4edd-45b3-85bc-bcbb8e1f1b17',
    '4': 'af131c2e-fbad-4ef1-917a-4922b2a21f99'
  };

  const FAQ_COPY_RIDS = {
    '1': { question: '92c5f7e9-7588-4e68-a758-387403cc2053', answer: 'e7e53484-234b-43ee-a1ab-c2355512a618' },
    '2': { question: '1b7ae905-c5be-47ef-9bfb-83c0d5707bf2', answer: '492aa9a2-1145-4e12-89b7-591ae78f28c4' },
    '3': { question: 'd70a0a17-0371-4431-b10a-f3d92d5f2643', answer: 'eb751e04-a1d5-4cc1-8b53-7e2ed03db418' },
    '4': { question: 'b7af5ebb-d3c3-4365-aee9-50203deb8fa4', answer: '57787d12-7af3-4450-bdae-76ac88b1ac5b' },
    '5': { question: '5d034545-55e4-484e-9901-c9a063a01560', answer: '5d9268bd-dee5-4bf0-a782-f0b3db96d183' },
    '6': { question: 'a77ea9ab-3d45-4455-b371-380a7e2e4783', answer: '28950294-8b89-48d4-8a42-cb5352d858fc' }
  };

  const parseConfig = (root) => {
    const node = root.querySelector('[data-hr-home-config]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('High Rider: invalid homepage configuration.', error);
      return null;
    }
  };

  const linkFromConfig = (config, key) => {
    const value = config?.links?.[key];
    return typeof value === 'string' && value.trim() ? value.trim() : null;
  };

  const elementsForRid = (root, rid) => root.querySelectorAll(`[data-rid="${rid}"]`);

  const setPlainText = (root, rid, value) => {
    if (!rid || typeof value !== 'string') return;

    elementsForRid(root, rid).forEach((element) => {
      const textRoot = element.querySelector('h1, h2, h3, p') || element;
      const styledLeaf = textRoot.querySelector('strong span, strong, span[style*="color"]');
      if (styledLeaf) {
        styledLeaf.textContent = value;
        return;
      }

      const directText = [...textRoot.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
      if (directText && textRoot.children.length) directText.nodeValue = value;
      else textRoot.textContent = value;
    });
  };

  const setMultilineHeading = (root, rid, value) => {
    if (typeof value !== 'string') return;

    elementsForRid(root, rid).forEach((element) => {
      const heading = element.querySelector('h1, h2, h3') || element;
      const lines = value.replace(/\r\n/g, '\n').split('\n');
      heading.replaceChildren();
      lines.forEach((line, index) => {
        if (index) heading.append(document.createElement('br'));
        heading.append(document.createTextNode(line));
      });
    });
  };

  const initializeContent = (root, config) => {
    const content = config?.content;
    if (!content) return;

    Object.entries(COPY_RIDS).forEach(([key, rid]) => setPlainText(root, rid, content[key]));
    setMultilineHeading(root, '53eefd54-4036-4a91-9b0f-5f14d809932c', content.goodHighHeading);

    content.products?.forEach((product) => {
      const rids = PRODUCT_COPY_RIDS[product.target];
      if (!rids) return;
      Object.entries(rids).forEach(([key, rid]) => setPlainText(root, rid, product[key]));
    });

    content.rewardBullets?.forEach((bullet) => {
      setPlainText(root, REWARD_COPY_RIDS[bullet.target], bullet.text);
    });

    content.faqs?.forEach((faq) => {
      const rids = FAQ_COPY_RIDS[faq.target];
      if (!rids) return;
      setPlainText(root, rids.question, faq.question);
      setPlainText(root, rids.answer, faq.answer);
    });
  };

  const disconnectGoodHighReveal = (root) => {
    const observer = revealObservers.get(root);
    if (!observer) return;

    observer.disconnect();
    revealObservers.delete(root);
  };

  const showGoodHighHeading = (root, disableMotion = false) => {
    const heading = root.querySelector(GOOD_HIGH_HEADING_SELECTOR);
    if (!heading) return;

    disconnectGoodHighReveal(root);

    if (disableMotion) {
      heading.style.animation = 'none';
      heading.style.opacity = '1';
      heading.style.transform = 'none';
    } else {
      heading.style.animation = 'none';
      void heading.offsetWidth;
      heading.style.animation = 'alchemy-grow 1000ms ease-in-out 0ms 1 normal both running';
    }

    heading.dataset.hrHomeRevealed = 'true';
  };

  const initializeGoodHighReveal = (root) => {
    const heading = root.querySelector(GOOD_HIGH_HEADING_SELECTOR);
    if (!heading || heading.dataset.hrHomeRevealInitialized === 'true') return;

    heading.dataset.hrHomeRevealInitialized = 'true';

    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      showGoodHighHeading(root, true);
      return;
    }

    if (window.getComputedStyle(heading).animationName === 'none') {
      showGoodHighHeading(root, true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        showGoodHighHeading(root);
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    );

    revealObservers.set(root, observer);
    observer.observe(heading);
  };

  const initializeAnchors = (root, config) => {
    Object.entries(ANCHOR_ACTIONS).forEach(([rid, linkKey]) => {
      const url = linkFromConfig(config, linkKey);
      if (!url) return;

      elementsForRid(root, rid).forEach((anchor) => {
        if (!(anchor instanceof HTMLAnchorElement)) return;

        anchor.href = url;
        anchor.removeAttribute('target');
        if (anchor.getAttribute('role') === 'button') anchor.removeAttribute('role');
      });
    });
  };

  const initializeDivLinks = (root, config) => {
    Object.entries(DIV_ACTIONS).forEach(([rid, action]) => {
      const url = linkFromConfig(config, action.link);
      if (!url) return;

      elementsForRid(root, rid).forEach((element) => {
        if (!(element instanceof HTMLDivElement)) return;

        element.setAttribute('role', 'link');
        if (!element.hasAttribute('tabindex')) element.tabIndex = 0;
        if (!element.hasAttribute('aria-label')) element.setAttribute('aria-label', action.label);

        if (element.dataset.hrHomeLinkInitialized === 'true') return;
        element.dataset.hrHomeLinkInitialized = 'true';

        const navigate = () => window.location.assign(url);

        element.addEventListener('click', navigate);
        element.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
          event.preventDefault();
          navigate();
        });
      });
    });
  };

  const setCollapsibleState = (collapsible, trigger, content, open) => {
    trigger.setAttribute('aria-expanded', String(open));
    collapsible.dataset.state = open ? 'open' : 'closed';
    content.dataset.state = open ? 'open' : 'closed';
    content.hidden = !open;
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible]').forEach((collapsible) => {
      const trigger = collapsible.querySelector(':scope > [role="button"][aria-controls]');
      if (!trigger) return;

      const contentId = trigger.getAttribute('aria-controls');
      const content = contentId ? document.getElementById(contentId) : null;
      if (!content || !root.contains(content)) return;

      const initiallyOpen = trigger.getAttribute('aria-expanded') === 'true';
      setCollapsibleState(collapsible, trigger, content, initiallyOpen);

      if (collapsible.dataset.hrHomeCollapsibleInitialized === 'true') return;
      collapsible.dataset.hrHomeCollapsibleInitialized = 'true';

      const toggle = () => {
        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        setCollapsibleState(collapsible, trigger, content, willOpen);
      };

      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        toggle();
      });
    });
  };

  const initialize = (root) => {
    const config = parseConfig(root);
    if (!config) return;

    initializeContent(root, config);
    initializeGoodHighReveal(root);
    initializeAnchors(root, config);
    initializeDivLinks(root, config);
    initializeCollapsibles(root);
  };

  const initializeAll = (container = document) => {
    if (container.matches?.(ROOT_SELECTOR)) initialize(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  };

  const cleanupAll = (container) => {
    if (container.matches?.(ROOT_SELECTOR)) disconnectGoodHighReveal(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(disconnectGoodHighReveal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupAll(event.target));
})();
